<template>
  <div class="row tight">
    <div class="col text-center">
      <under-input v-model.number="attribute.score" maxlength="2">Score</under-input>
    </div>
    <div class="col-3 text-center">
      <under-text>
        <div slot="underline" class="header capitalize">{{ name.substring(0, 3) }}</div>
        <span class="capitalize">{{ name }}</span>
      </under-text>
    </div>
    <div class="col text-center">
      <under-text>
        <ez-modal-dice
          slot="underline"
          :name="name"
          :dice="`1d20+${scoreBonus}`">
          {{ scoreBonus }}
        </ez-modal-dice>
        Mod
      </under-text>
    </div>
    <div class="col text-center">
      <under-checkbox v-model="attribute.proficient">Prof</under-checkbox>
    </div>
    <div class="col text-center">
      <under-input v-model.number="attribute.misc" maxlength="2">Misc</under-input>
    </div>
    <div class="col text-center">
      <under-text>
        <ez-modal-dice
          slot="underline"
          :name="name"
          :dice="`1d20+${saveBonus}`">
          {{ saveBonus }}
        </ez-modal-dice>
        Save
      </under-text>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import UnderCheckbox from "../shared/_UnderCheckbox.vue";
import UnderInput from "../shared/_UnderInput.vue";
import UnderText from "../shared/_UnderText.vue";

export default {
  name: "sections-attributes-fifth-edition",
  components: {
    EzModalDice,
    UnderCheckbox,
    UnderInput,
    UnderText
  },
  props: ["attribute", "name"],
  computed: {
    ...mapState({
      experience: state => state.characters.current.core.experience
    }),
    proficiencyBonus() {
      return this.$rpgv.d20.proficiencyBonus(this.experience);
    },
    scoreBonus() {
      return Math.floor((this.attribute.score - 10) / 2);
    },
    saveBonus() {
      let scoreBonus = this.scoreBonus;
      let bonus = scoreBonus;
      if (this.attribute.proficient && this.proficiencyBonus)
        bonus += this.proficiencyBonus;
      if (this.attribute.misc) bonus += this.attribute.misc;
      return bonus;
    }
  }
};
</script>
